var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.report)?_c('sponsor-day-of-event-display',{attrs:{"report":_vm.report},scopedSlots:_vm._u([{key:"heading",fn:function(){return [_vm._v("Event Information")]},proxy:true}],null,false,4173029845)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }